import {InviteLinkHistoryResponse} from "libs/apiClient";
import {formatDateTime, getInviteLinkRoleLabel, getInviteLinkTypeLabel} from "features/discover/functions";
import {Link} from "react-router";

export function InviteLinksHistoryTable({
	inviteLinksHistory
}: {
	inviteLinksHistory: InviteLinkHistoryResponse[]
}) {
	if (inviteLinksHistory.length === 0) {
		return <div className="empty-sub-table">No links</div>
	}

    return (
		<table className="discover-table">
			<thead>
				<tr>
					<th>ID</th>
					<th>Type</th>
					<th>Role</th>
					<th>Accepted by</th>
					<th>Accepted at</th>
					<th>Invite link ID</th>
				</tr>
			</thead>
			<tbody>
				{inviteLinksHistory.map((il: InviteLinkHistoryResponse, index) => (
					<tr key={`row-${index}`}>
						<td>{il.id}</td>
						<td>
							{getInviteLinkTypeLabel(il.type)}
						</td>
						<td>
							{getInviteLinkRoleLabel(il.role)}
						</td>
						<td>
							{il.acceptedBy ? <Link to={`/discover/user/${il.acceptedBy.id}`}>{il.acceptedBy.name}</Link> : '-'}
						</td>
						<td>
							{formatDateTime(il.createdAt)}
						</td>
						<td>
							{il.inviteLinkId || '-'}
						</td>
					</tr>
				))}
			</tbody>
		</table>
	)
}
